import React, { Component } from "react";
import { endPoints } from "../config";

import { history } from "../history/history";
import { sales_menu } from "./salesUser_menu_option";
const salesusermenu = sales_menu();
class SalesUserSideMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      salesuserInfo: JSON.parse(localStorage.getItem("salesUserInfo")),
    };
    if (this.state.salesuserInfo.kycstatus && this.state.salesuserInfo.kycstatus.status === "Verified") {
      this.state.menuOptions = salesusermenu;      
    } else {
      this.state.menuOptions = salesusermenu.filter((e) => {
        return e.name === "KYC";
      });
    }
  }
  //Handle active class
  activeClass = (menu) => {
    if (this.props.match.path === menu.link) {
      return true;
    }
    return false;
  };

  //Checking submenu
  checkSubMenu = (subMenuArr) => {
    let show = false;
    subMenuArr.map((subMenuObj) => {
      if (this.props.match.path === subMenuObj.link) {
        show = true;
        return show;
      }
    });
    return show;
  };

  //Show the sidebar for sales user
  render() {
    let { menuOptions } = this.state;
    return (
      <div className="side_menu_wrapper">
        <div
          className="logo_header"
          onClick={() => {
            history.push({ pathname: "/tp/login" });
          }}
        >
          <img src="../../assets/images/dash_logo.png" />
        </div>
        <div className="menu_item_wrapper">
          <ul className="item_wrapper">
            {menuOptions.map((menu, index) => {
              return (
                <li
                  key={index}
                  className={
                    this.activeClass(menu)
                      ? "item_inner active"
                      : this.checkSubMenu(menu.subMunu)
                      ? "item_inner active"
                      : "item_inner"
                  }
                >
                  <a
                    onClick={() => {
                      window.location.pathname = menu.link
                      // history.push(menu.link);
                    }}
                  >
                    <span>
                      <img src={menu.white_image} className="white" />
                      <img src={menu.blue_image} className="blue" />
                    </span>
                    <span>{menu.name}</span>
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
        <p className="copyright_txt">
          Copyright @2019 BigFM. All Rights Reserved
        </p>
      </div>
    );
  }
}

export default SalesUserSideMenu;



// WEBPACK FOOTER //
// ./web/menu/SalesUserSideMenu.jsx